import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { endOfDayInMilliseconds, startOfDayInMilliseconds } from '@utils/date';

import { IPage, IPageSize, ISearchValue, ISort, TDefaultStoreDTO } from '@interfaces/common/store';

import { defaultMeta } from '@enums/common';

interface IInitialState extends TDefaultStoreDTO {
	createdAtFrom: number | null;
	createdAtTo: number | null;
	organizationUser: string | null;
	userAction: string | null;
}

const initialState: IInitialState = {
	...defaultMeta,
	searchValue: '',
	sortDirection: false,
	sortFieldName: null,
	createdAtFrom: null,
	createdAtTo: null,
	organizationUser: null,
	userAction: null,
};

const userHistory = createSlice({
	name: 'userHistory',
	initialState,
	reducers: {
		setPage: (state, action: PayloadAction<IPage>) => {
			state.page = action.payload.page;
		},
		setPageSize: (state, action: PayloadAction<IPageSize>) => {
			state.pageSize = action.payload.pageSize;
			state.page = initialState.page;
		},
		setSort: (state, action: PayloadAction<ISort>) => {
			state.sortDirection = action.payload.sortDirection;
			state.sortFieldName = action.payload.sortFieldName;
		},
		setOrganizationUser: (state, action: PayloadAction<{ organizationUser: string | null }>) => {
			state.organizationUser = action.payload.organizationUser;
			state.page = initialState.page;
		},
		setUserAction: (state, action: PayloadAction<{ userAction: string | null }>) => {
			state.userAction = action.payload.userAction;
			state.page = initialState.page;
		},
		setSearchValue: (state, action: PayloadAction<ISearchValue>) => {
			state.searchValue = action.payload.searchValue;
			state.page = initialState.page;
		},
		setCreatedAt: (state, action: PayloadAction<{
			createdAtFrom?: number | null;
			createdAtTo?: number | null;
		}>) => {
			if (action.payload.createdAtFrom) {
				state.createdAtFrom = startOfDayInMilliseconds(action.payload.createdAtFrom);
			} else state.createdAtFrom = null;

			if (action.payload.createdAtTo) {
				state.createdAtTo = endOfDayInMilliseconds(action.payload.createdAtTo);
			} else state.createdAtTo = null;

			state.page = initialState.page;
		},
		resetUserHistory: () => initialState,
	},
});

export const {
	setPage,
	setPageSize,
	setSort,
	setSearchValue,
	setCreatedAt,
	setOrganizationUser,
	setUserAction,
	resetUserHistory,
} = userHistory.actions;

export default userHistory.reducer;
